import { render } from "./UiFullScreenLoader.vue?vue&type=template&id=1eba709e&scoped=true&lang=pug"
import script from "./UiFullScreenLoader.vue?vue&type=script&lang=js"
export * from "./UiFullScreenLoader.vue?vue&type=script&lang=js"

import "./UiFullScreenLoader.vue?vue&type=style&index=0&id=1eba709e&lang=sass&scoped=true"

import exportComponent from "/home/runner/work/valeriya-artist/valeriya-artist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eba709e"]])

export default __exports__